import baseRequest from '../baseRequest';
import AppConfig from '../../app/config/AppConfig';

/* actions */
import * as Actions from '../../redux/actions';
import {addPopup} from '../../redux/actions';
import * as popups from "../../constants/popup-types";


class BenefitByIdRequest extends baseRequest {

    constructor() {
        super();
        this.dispatch = null;
        this.response = null;
        this.name = 'benefit page';
        this.Config = new AppConfig();
    }

    execute(dispatch, payload) {
        this.dispatch = dispatch;
        this.dispatch(Actions.setBenefitPage(false));
        this.dispatch(Actions.setDynamicLink(false));
        if (payload.isCommerce)
            this.call(this.Config.api.requests.getDetailedTradeBenefit, payload)
        else
            this.call(this.Config.api.requests.getDetailedBenefitByIdForWeb, payload);
    }

    // custom on failure
    onFailure(response, methodName = '') {
        this.dispatch(addPopup({
            type: popups.GENERAL_MESSAGE,
            text: response.err.content,
            popup_id: Math.round(Math.random() * 1000000),
        }));

        this.dispatch(Actions.setBenefitPage('error'));
    }

    //Parse successful response
    onSuccess() {
        this.updateState();
    }

    //Dispatch actions to update redux state
    updateState() {
        this.dispatch(Actions.setDynamicLink(
            typeof this.response.data.main?.dynamicLink ?
                this.response.data.main?.dynamicLink : false
        ));
        this.dispatch(Actions.setBenefitPage(this.response.data));
    }

}


export default BenefitByIdRequest;
